<template>
  <div v-if="chips.length" class="license-recommend-chips">
    <p class="license-recommend-chips__title">よく入力される免許・資格</p>
    <div class="license-recommend-chips__list">
      <button
        v-for="chip in chips"
        :key="chip.text"
        type="button"
        class="license-recommend-chips__chip"
        @click="emit('select', chip.text)"
      >
        <i class="el-icon-plus"></i>{{ chip.label }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, shallowRef } from 'vue'
import {
  loadLicenseSuggestIndex,
  recommendLicenses,
  type LicenseSuggestIndex
} from '@/utils/format-edit/licenseSuggest'

const props = defineProps<{
  /** 入力済みの免許・資格（これらはおすすめから外す） */
  entered: string[]
}>()

const emit = defineEmits<{ (e: 'select', text: string): void }>()

const index = shallowRef<LicenseSuggestIndex | null>(null)
loadLicenseSuggestIndex()
  .then((loaded) => {
    index.value = loaded
  })
  .catch(() => {})

const chips = computed(() =>
  index.value ? recommendLicenses(index.value, props.entered) : []
)
</script>

<style scoped lang="scss">
$chip-border: #dcdfe6;
$chip-text: #404040;
$chip-hover: #f0f9eb;
$chip-hover-border: #67c23a;

.license-recommend-chips {
  margin-bottom: 12px;
  text-align: left;
}

.license-recommend-chips__title {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: bold;
}

.license-recommend-chips__list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.license-recommend-chips__chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border: 1px solid $chip-border;
  border-radius: 16px;
  background: none;
  color: $chip-text;
  font-size: 13px;
  line-height: 1.4;
  text-align: left;
  cursor: pointer;

  &:hover {
    border-color: $chip-hover-border;
    background-color: $chip-hover;
  }
}
</style>
